module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_1_03-b54fe24868cd44e24bc6946f708cc39d.jpg";